import React, { useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import theme from "./theme";
import "./App.css";
import { ThemeProvider, CssBaseline, Typography } from "@mui/material";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  useParams,
} from "react-router-dom";
import Layout from "./Layout/Layout";
import Operations from "./Views/Operations/Operations";
import Home from "./Views/Home/Home";
import BusinessDescription from "./Views/Operations/BusinessDescription/BusinessDescription";
import SipocDiagram from "./components/Reusable/Admin/Users/SipocDiagram";
import ProtectedRoute from "./components/ProtectedRoute";
import { MsalProvider } from "@azure/msal-react";
import { MSAL_CONFIG } from "./components/config/msalConfig";
import RoutineUpload from "./components/Routine&Performance/MCRUpload";
import GlobalPoliciesUpload from "./components/GlobalPolicies/GlobalPoliciesUpload";
import FPSUpload from "./components/GlobalPolicies/FPSUpload";
import ActivityBible from "./components/ActivityBible/ActivityBible";
import KnowledgeManagement from "./components/KnowledgeManagement/KnowledgeManagement";

import LoginPage from "./components/LoginPage/LoginPage";
import RisksSecurity from "./components/RiskSecurity/RisksSecurity";

import ProjectManagementUpload from "./components/ProjectManagement/ProjectManagementUpload";
import PPI from "./components/GlobalPolicies/PPI";
import CustomerCentricity from "./components/Routine&Performance/CustomerCentricity";
import AdminProcessMapNew from "./Views/Admin/AdminOperations/AdminProcessMap/AdminProcessMapNew";
import UserSection from "./components/Reusable/UserSection/UserSection";
import LearningDevelopmentUpload from "./components/Routine&Performance/LearningDevelopmentUpload";
import WorkEnvEngagementUpload from "./components/Routine&Performance/WorkEnvEngagementUpload";
import TalentGrowthUpload from "./components/Routine&Performance/TalentGrowthUpload";
import RewardsRecognitionUpload from "./components/Routine&Performance/RewardsRecognitionUpload";
import PeopleDataAnalyticsUpload from "./components/Routine&Performance/PeopleDataAnalyticsUpload";
import CultureSection from "./components/RiskSecurity/CultureSection";
import RecruitmentSelectionSection from "./components/RiskSecurity/RecruitmentSelectionSection";
import CapexOpexSection from "./components/RiskSecurity/CapexOpexSection";
import BusinessCycleUpload from "./components/Routine&Performance/BusinessCycleUpload";
import InflowdemanProcessSection from "./components/RiskSecurity/InflowdemanProcessSection";

import StrategyValue from "./Views/Strategy/Strategyandvaluecreation/StrategyValue";
import RiskSecurityUserSection from "./components/Reusable/UserSection/RiskSecurityUserSection";
import StrategyValueAdmin from "./Views/Strategy/Strategyandvaluecreation/StrategyValueAdmin";
import UserSectionMultiTab from "./components/Reusable/UserSection/UserSectionMultiTab";
import UserSectionMultiSubTab from "./components/Reusable/UserSection/UserSectionMultiSubTab";
import UserSectionMultiTabPeople from "./components/Reusable/UserSection/UserSectionMultiTabPeople";
import UserSectionPeople from "./components/Reusable/UserSection/UserSectionPeople";
import UserSectionMultiTabValueCreation from "./components/Reusable/UserSection/UserSectionMultiTabValueCreation";
import StrategyValueUser from "./Views/Strategy/Strategyandvaluecreation/StrategyValueUser";
import ComingSoon from "./components/ComingSoon";
import GbsCrossChargeUpload from "./components/Routine&Performance/GbsCrossChargeUpload";
import FeedbackView from "./Views/Operations/FeedbackView";
import RoleBasedComponent from "./RoleBasedComponent";
import Help from "./Views/Operations/Help";
import HelpSuperAdmin from "./Views/Operations/HelpSuperAdmin";
import BusinessDescriptionForm from "./components/Reusable/Forms/BusinessDescriptionForm";
import Dashboard from "./Views/Dashboard/dashboard";
import SectionSlider from "./components/Reusable/SectionSlider/SectionSlider";
import { sectionPaths, sections } from "./constants/sectionData";
import { Link } from "react-router-dom";
import ActivityBar from "./components/Reusable/ActivityBar/ActivityBar";
import ResultDashboard from "./Views/Dashboard/ResultDashboard";
import ResultDeepdive from "./Views/Dashboard/ResultDeepdive";

const BusinessDescriptionFormWrapper = () => {
  const location = useLocation();
  const { id } = useParams();
  const management =
    localStorage.getItem("management") || "Default Location Name";

  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/operations/management">
      Evidence Upload
    </Link>,
    <Link key="3" color="#000" to="/operations/management">
      Management
    </Link>,
    <Typography key="4" sx={{ fontWeight: "bold" }}>
      {management}
    </Typography>,
  ];

  // Initialize with location state or empty values
  const initialProps = {
    functionL1: location.state?.functionL1 || "",
    functionL2: location.state?.functionL2 || "",
    management: location.state?.management || "",
  };

  const [formProps, setFormProps] = useState(initialProps);

  // Only update if location.state changes
  useEffect(() => {
    if (location.state) {
      setFormProps({
        functionL1: location.state.functionL1 || "",
        functionL2: location.state.functionL2 || "",
        management: location.state.management || "",
      });
    }
  }, [location.state]);

  // Use id as key to force remount when id changes
  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />

      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Business Description"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      <BusinessDescriptionForm
        key={id} // This forces remount when ID changes
        functionL1={formProps.functionL1}
        functionL2={formProps.functionL2}
        management={formProps.management}
      />
    </>
  );
};
// Create a RoleBasedWrapper component
const RoleBasedWrapper = ({
  managerComponent,
  adminComponent,
  superadminComponent,
  userComponent,
}: {
  managerComponent: React.ReactNode;
  adminComponent: React.ReactNode;
  superadminComponent: React.ReactNode;
  userComponent?: React.ReactNode;
}) => {
  return (
    <RoleBasedComponent
      managerComponent={managerComponent}
      adminComponent={adminComponent}
      superadminComponent={superadminComponent}
      userComponent={userComponent}
    />
  );
};
// Define your router here
const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "/feedback",
            element: <FeedbackView />,
          },
          {
            path: "operations/management",
            element: <Operations />,
          },
          {
            path: "comingsoon",
            element: <ComingSoon />,
          },
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "result-dashboard",
            element: <ResultDashboard />,
          },
          {
            path: "result-deepdive",
            element: <ResultDeepdive />,
          },
          {
            path: "/help",
            element: (
              <RoleBasedComponent
                key="help"
                managerComponent={<Help />}
                adminComponent={<Help />}
                superadminComponent={<HelpSuperAdmin />}
                userComponent={<Help />}
              />
            ),
          },
          // business description routes
          {
            path: "operations/management/business-description",
            element: (
              <RoleBasedComponent
                key="business-description"
                managerComponent={<BusinessDescription />}
                adminComponent={<BusinessDescription />}
                superadminComponent={<BusinessDescription />}
                userComponent={<SipocDiagram />}
              />
            ),
          },

          {
            path: "/operations/management/edit/:id",
            element: (
              <RoleBasedWrapper
                key="business-description-edit"
                managerComponent={<BusinessDescriptionFormWrapper />}
                adminComponent={<BusinessDescriptionFormWrapper />}
                superadminComponent={<BusinessDescriptionFormWrapper />}
              />
            ),
          },

          // {
          //   path: "/operations/management/edit/:id",
          //   // element: <BusinessDescriptionForm
          //   //   functionL1={location.state.functionL1}
          //   //   functionL2={location.state.functionL2}
          //   //   management={location.state.management}

          //   element: (
          //     <RoleBasedComponent
          //       managerComponent={(() => {
          //         const location = useLocation() as { state: { functionL1: string; functionL2: string; management: string } };
          //         return <BusinessDescriptionForm
          //           functionL1={location.state?.functionL1 || ''}
          //           functionL2={location.state?.functionL2 || ''}
          //           management={location.state?.management || ''}
          //         />;
          //       })()}
          //       adminComponent={(() => {
          //         const location = useLocation() as { state: { functionL1: string; functionL2: string; management: string } };
          //         return <BusinessDescriptionForm
          //           functionL1={location.state?.functionL1 || ''}
          //           functionL2={location.state?.functionL2 || ''}
          //           management={location.state?.management || ''}
          //         />;
          //       })()}
          //       superadminComponent={(() => {
          //         const location = useLocation() as { state: { functionL1: string; functionL2: string; management: string } };
          //         return <BusinessDescriptionForm
          //           functionL1={location.state?.functionL1 || ''}
          //           functionL2={location.state?.functionL2 || ''}
          //           management={location.state?.management || ''}
          //         />;
          //       })()}
          //       userComponent={(() => {
          //         const location = useLocation() as { state: { functionL1: string; functionL2: string; management: string } };
          //         return <BusinessDescriptionForm
          //           functionL1={location.state?.functionL1 || ''}
          //           functionL2={location.state?.functionL2 || ''}
          //           management={location.state?.management || ''}
          //         />;
          //       })()}

          //     />
          //   )
          // },

          // process map routes
          {
            path: "operations/management/process-map",
            element: (
              <RoleBasedComponent
                key="process-map"
                managerComponent={<AdminProcessMapNew isManager={true} />}
                adminComponent={<AdminProcessMapNew isAdmin={true} />}
                superadminComponent={<AdminProcessMapNew isAdmin={true} />}
                userComponent={
                  <UserSection
                    levels={3}
                    fetchAllFilesApi="/management/filter_process_map"
                    fetchFileViewApi="/management/process_map"
                    sectionTitle="Process Map"
                    highlightSection="Process Map"
                    verticalTabs={[{ label: "Process Map", value: "a" }]}
                  />
                }
              />
            ),
          },

          // MSRc Routes
          {
            path: "operations/management/mcrs",
            element: (
              <RoleBasedComponent
                key="mcrs"
                managerComponent={<RoutineUpload isManager={true} />}
                adminComponent={<RoutineUpload isAdmin={true} />}
                superadminComponent={<RoutineUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTab
                    levels={3}
                    fetchAllFilesApi="/management/filter_mcrs"
                    fetchFileViewApi="/management/mcrs"
                    highlightSection="MCRs"
                    verticalTabs={[
                      { label: "Routine & Performance Review", value: "a" },
                      { label: "Routine Stakeholder Connects", value: "b" },
                      { label: "TOR(Terms of Reference)", value: "c" },
                      { label: "Escalation Management", value: "d" },
                      { label: "Target Management", value: "e" },
                    ]}
                  />
                }
              />
            ),
          },

          // global policies routes
          {
            path: "operations/management/global-policies",
            element: (
              <RoleBasedComponent
                key="global-policies"
                managerComponent={<GlobalPoliciesUpload isManager={true} />}
                adminComponent={<GlobalPoliciesUpload isAdmin={true} />}
                superadminComponent={<GlobalPoliciesUpload isAdmin={true} />}
                userComponent={
                  <UserSection
                    levels={1}
                    fetchAllFilesApi="/management/filter_global_polices"
                    fetchFileViewApi="/management/global_polices"
                    sectionTitle="MICS Action Plan"
                    highlightSection="Global Policies"
                    verticalTabs={[{ label: "MICS Action Plan", value: "a" }]}
                  />
                }
              />
            ),
          },

          // project management routes
          {
            path: "operations/management/project-management",
            element: (
              <RoleBasedComponent
                key="project-management"
                managerComponent={<ProjectManagementUpload isManager={true} />}
                adminComponent={<ProjectManagementUpload isAdmin={true} />}
                superadminComponent={<ProjectManagementUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiSubTab
                    levels={1}
                    fetchAllFilesApi="/management/filter_project_management"
                    fetchFileViewApi="/management/project_management"
                    highlightSection="Project Management"
                    verticalTabs={[
                      { label: "Project Management", value: "a" },
                      {
                        label: "Change Management",
                        value: "b",
                        subTabs: [
                          { label: "Risk Assessment", value: "c" },
                          {
                            label: "Success Change Management Plan",
                            value: "d",
                          },
                        ],
                      },
                    ]}
                  />
                }
              />
            ),
          },

          // frontline problem solving
          {
            path: "operations/management/frontline-problem-solving",
            element: (
              <RoleBasedComponent
                key="frontline-problem-solving"
                managerComponent={<FPSUpload isManager={true} />}
                adminComponent={<FPSUpload isAdmin={true} />}
                superadminComponent={<FPSUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTab
                    levels={1}
                    fetchAllFilesApi="/management/filter_frontline_problem_solving"
                    fetchFileViewApi="/management/frontline_problem_solving"
                    highlightSection="Frontline Problem Solving"
                    verticalTabs={[
                      {
                        label:
                          "Continuous Improvement Methods & Transformation",
                        value: "a",
                      },
                      { label: "Chronic Problems", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // Product and Process Indicators
          {
            path: "operations/management/product-and-process-indicators",
            element: (
              <RoleBasedComponent
                key="product-and-process-indicators"
                managerComponent={<PPI isManager={true} />}
                adminComponent={<PPI isAdmin={true} />}
                superadminComponent={<PPI isAdmin={true} />}
                userComponent={
                  <UserSection
                    levels={4}
                    fetchAllFilesApi="/management/filter_product_process_indicator"
                    fetchFileViewApi="/management/product_process_indicator"
                    sectionTitle="Product and Process Indicators"
                    highlightSection="Product and Process Indicators"
                    verticalTabs={[
                      { label: "Product and Process Indicators", value: "a" },
                    ]}
                  />
                }
              />
            ),
          },

          // Customer Centricity Routes

          {
            path: "operations/management/customer-centricity",
            element: (
              <RoleBasedComponent
                key="customer-centricity"
                managerComponent={<CustomerCentricity isManager={true} />}
                adminComponent={<CustomerCentricity isAdmin={true} />}
                superadminComponent={<CustomerCentricity isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTab
                    levels={3}
                    fetchAllFilesApi="/management/filter_customer_centricity"
                    fetchFileViewApi="/management/customer_centricity"
                    highlightSection="Customer Centricity"
                    verticalTabs={[
                      { label: "Contact Model Platform", value: "a" },
                      { label: "SLA Action Plans (Contact Model)", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // Change Management
          // {
          //   path: "operations/management/change-management",
          //   element: (
          //     <RoleBasedComponent
          //       managerComponent={<ChangeManagementUpload isManager={true} />}
          //       adminComponent={<ChangeManagementUpload isAdmin={true} />}
          //       userComponent={<UserSectionMultiTab fetchAllFilesApi="/management/filter_customer_centricity" fetchFileViewApi="/management/customer_centricity" highlightSection='Customer Centricity' verticalTabs={[
          //         { label: "Contact Model Platform", value: "a" },
          //         { label: "SLA Action Plans (Contact Model)", value: "b" },

          //       ]} />}
          //     />
          //   )
          // },

          // risk and magnagement routes

          {
            path: "operations/management/risk-security",
            element: (
              <RoleBasedComponent
                key="risk-security"
                managerComponent={<RisksSecurity isManager={true} />}
                adminComponent={<RisksSecurity isAdmin={true} />}
                superadminComponent={<RisksSecurity isAdmin={true} />}
                userComponent={
                  <RiskSecurityUserSection
                    fetchAllFilesApi="/management/filter_risk_security"
                    fetchFileViewApi="/management/risk_security"
                    sectionTitle="Risk Management Tools"
                    highlightSection="Risks and Security"
                    verticalTabs={[
                      { label: "Risk Management Tools", value: "a" },
                    ]}
                  />
                }
              />
            ),
          },

          {
            path: "/operations/management/activity-bible",
            element: <ActivityBible />,
          },

          // standard creation execution routes

          {
            path: "/operations/management/standard-creation-execution",
            element: <KnowledgeManagement />,
          },

          // People Routes
          // culture  routes

          {
            path: "/operations/people/culture",
            element: (
              <RoleBasedComponent
                key="culture"
                managerComponent={<CultureSection isManager={true} />}
                adminComponent={<CultureSection isAdmin={true} />}
                superadminComponent={<CultureSection isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_culture"
                    fetchFileViewApi="/people/culture"
                    highlightSection="Culture"
                    verticalTabs={[
                      { label: "Annual Event", value: "a" },
                      { label: "10 Principles", value: "b" },
                      { label: "Company Induction", value: "c" },
                    ]}
                  />
                }
              />
            ),
          },

          // Recruitment & Selection Routes
          {
            path: "/operations/people/recruitment-selection",
            element: (
              <RoleBasedComponent
                key="recruitment-selection"
                managerComponent={
                  <RecruitmentSelectionSection isManager={true} />
                }
                adminComponent={<RecruitmentSelectionSection isAdmin={true} />}
                superadminComponent={
                  <RecruitmentSelectionSection isAdmin={true} />
                }
                userComponent={
                  <UserSectionMultiTabPeople
                    levels={2}
                    isFilter={true}
                    fetchAllFilesApi="/people/filter_recruitment_n_selection"
                    fetchFileViewApi="/people/recruitment_n_selection"
                    highlightSection="Recruitment & Selection"
                    verticalTabs={[
                      { label: "Recruitment Partners", value: "a" },
                      { label: "Job Description", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // Learning & Development
          {
            path: "/operations/people/learning-development",
            element: (
              <RoleBasedComponent
                key="learning-development"
                managerComponent={
                  <LearningDevelopmentUpload isManager={true} />
                }
                adminComponent={<LearningDevelopmentUpload isAdmin={true} />}
                superadminComponent={
                  <LearningDevelopmentUpload isAdmin={true} />
                }
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_learning_n_development"
                    fetchFileViewApi="/people/learning_n_development"
                    highlightSection="Learning & Development"
                    verticalTabs={[
                      { label: "Buddy Program", value: "a" },
                      { label: "Training Plan", value: "b" },
                      { label: "Training feedback", value: "c" },
                      { label: "Training Calendar", value: "d" },
                      { label: "Learning Effectiveness", value: "e" },
                    ]}
                  />
                }
              />
            ),
          },

          // Work Environment & Engagement
          {
            path: "/operations/people/work-environment-engagement",
            element: (
              <RoleBasedComponent
                key="work-environment-engagement"
                managerComponent={<WorkEnvEngagementUpload isManager={true} />}
                adminComponent={<WorkEnvEngagementUpload isAdmin={true} />}
                superadminComponent={<WorkEnvEngagementUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_workenv_n_engagement"
                    fetchFileViewApi="/people/workenv_n_engagement"
                    highlightSection="Work Environment & Engagement"
                    verticalTabs={[
                      { label: "Engagement Plan", value: "a" },
                      { label: "Work Life Balance", value: "b" },
                      { label: "Leaves Management", value: "c" },
                    ]}
                  />
                }
              />
            ),
          },

          // Work Environment & Engagement
          {
            path: "/operations/people/work-environment-engagement",
            element: (
              <RoleBasedComponent
                key="work-environment-engagement"
                managerComponent={<WorkEnvEngagementUpload isManager={true} />}
                adminComponent={<WorkEnvEngagementUpload isAdmin={true} />}
                superadminComponent={<WorkEnvEngagementUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_workenv_n_engagement"
                    fetchFileViewApi="/people/workenv_n_engagement"
                    highlightSection="Work Environment & Engagement"
                    verticalTabs={[
                      { label: "Engagement Plan", value: "a" },
                      { label: "Work Life Balance", value: "b" },
                      { label: "Leaves Management", value: "c" },
                    ]}
                  />
                }
              />
            ),
          },

          // Talent & Growth
          {
            path: "/operations/people/talent-growth",
            element: (
              <RoleBasedComponent
                key="talent-growth"
                managerComponent={<TalentGrowthUpload isManager={true} />}
                adminComponent={<TalentGrowthUpload isAdmin={true} />}
                superadminComponent={<TalentGrowthUpload isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_talent_n_growth"
                    fetchFileViewApi="/people/talent_n_growth"
                    highlightSection="Talent & Growth"
                    verticalTabs={[
                      { label: "People Cycle", value: "a" },
                      { label: "Exit Interviews", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // Rewards & Recognition
          {
            path: "/operations/people/rewards-recognition",
            element: (
              <RoleBasedComponent
                key="rewards-recognition"
                managerComponent={<RewardsRecognitionUpload isManager={true} />}
                adminComponent={<RewardsRecognitionUpload isAdmin={true} />}
                superadminComponent={
                  <RewardsRecognitionUpload isAdmin={true} />
                }
                userComponent={
                  <UserSectionMultiTabPeople
                    fetchAllFilesApi="/people/filter_rewards_n_recognition"
                    fetchFileViewApi="/people/rewards_n_recognition"
                    highlightSection="Rewards & Recognition"
                    verticalTabs={[
                      { label: "Compensation and Benefits", value: "a" },
                      { label: "Global Reward Platform", value: "b" },
                      { label: "Career Growth", value: "c" },
                      { label: "Job Grading", value: "d" },
                      { label: "Recognition Program", value: "e" },
                    ]}
                  />
                }
              />
            ),
          },

          // People Data & Analytics
          {
            path: "/operations/people/people-data-analytics",
            element: (
              <RoleBasedComponent
                key="people-data-analytics"
                managerComponent={
                  <PeopleDataAnalyticsUpload isManager={true} />
                }
                adminComponent={<PeopleDataAnalyticsUpload isAdmin={true} />}
                superadminComponent={
                  <PeopleDataAnalyticsUpload isAdmin={true} />
                }
                userComponent={
                  <UserSectionPeople
                    fetchAllFilesApi="/people/filter_people_n_analytics"
                    fetchFileViewApi="/people/people_n_analytics"
                    sectionTitle="People Data & Analytics"
                    highlightSection="People Data & Analytics"
                    verticalTabs={[{ label: "Blueprint", value: "a" }]}
                  />
                }
              />
            ),
          },

          // Strategy & Value creation Routes
          {
            path: "operations/strategy-value-creation",
            element: <Operations strategyTab={true} />,
          },

          {
            path: "operations/strategy-value-creation/vsp",
            element: (
              <RoleBasedComponent
                key="strategy-value-creation/vsp"
                managerComponent={<StrategyValue />}
                adminComponent={<StrategyValueAdmin />}
                superadminComponent={<StrategyValueAdmin />}
                userComponent={<StrategyValueUser />}
              />
            ),
          },

          //  Value Creation through resources allocation Routes
          {
            path: "/operations/strategy-value-creation/vctra/capex-opex",
            element: (
              <RoleBasedComponent
                key="strategy-value-creation/vctra/capex-opex"
                managerComponent={<CapexOpexSection isManager={true} />}
                adminComponent={<CapexOpexSection isAdmin={true} />}
                superadminComponent={<CapexOpexSection isAdmin={true} />}
                userComponent={
                  <UserSectionMultiTabValueCreation
                    fetchAllFilesApi="/strategy/filter_strategy_n_value_creation"
                    fetchFileViewApi="/strategy/strategy_n_value_creation"
                    highlightSection="GBS CAPEX and OPEX Allocation"
                    tabName="GBS CAPEX and OPEX Allocation"
                    verticalTabs={[
                      { label: "CAPEX Spend & Benefits", value: "a" },
                      { label: "OPEX Reports", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // Business Cycle and Value Creation Process
          {
            path: "/operations/strategy-value-creation/vctra/bcvcp",
            element: (
              <RoleBasedComponent
                key="strategy-value-creation/vctra/bcvcp"
                managerComponent={
                  <BusinessCycleUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="Business Cycle and Value Creation Process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isManager={true}
                    verticalTabs={[
                      { label: "T&M Routine - CAPEX", value: "a" },
                      { label: "T&M Routine - OPEX", value: "b" },
                      {
                        label: "People Planning and Performance Management",
                        value: "c",
                      },
                      { label: "People Cost Center master-data", value: "d" },
                    ]}
                    highlightSection="Business Cycle and Value Creation Process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine is in place to produce LE and analyze AC vs BU for CAPEX spend, Benefits and KPIs for CAPEX projects impacting BSC.",
                      b: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine in place to produce LE and analyze AC vs BU for OPEX spend, incl. total FTE (productivity evolution).",
                      c: "Upload Reports on FTE forecast, AC/LE people costs, drivers of deviation, initiatives.",
                      d: "Upload Data validation reports and compliance checklists for master-data including BSC People Cost Center master-data is correct and in line with People and GBS Policies (applicable for GBS services).",
                    }}
                  />
                }
                adminComponent={
                  <BusinessCycleUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="Business Cycle and Value Creation Process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isAdmin={true}
                    verticalTabs={[
                      { label: "T&M Routine - CAPEX", value: "a" },
                      { label: "T&M Routine - OPEX", value: "b" },
                      {
                        label: "People Planning and Performance Management",
                        value: "c",
                      },
                      { label: "People Cost Center master-data", value: "d" },
                    ]}
                    highlightSection="Business Cycle and Value Creation Process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine is in place to produce LE and analyze AC vs BU for CAPEX spend, Benefits and KPIs for CAPEX projects impacting BSC.",
                      b: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine in place to produce LE and analyze AC vs BU for OPEX spend, incl. total FTE (productivity evolution).",
                      c: "Upload Reports on FTE forecast, AC/LE people costs, drivers of deviation, initiatives.",
                      d: "Upload Data validation reports and compliance checklists for master-data including BSC People Cost Center master-data is correct and in line with People and GBS Policies (applicable for GBS services).",
                    }}
                  />
                }
                superadminComponent={
                  <BusinessCycleUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="Business Cycle and Value Creation Process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isAdmin={true}
                    verticalTabs={[
                      { label: "T&M Routine - CAPEX", value: "a" },
                      { label: "T&M Routine - OPEX", value: "b" },
                      {
                        label: "People Planning and Performance Management",
                        value: "c",
                      },
                      { label: "People Cost Center master-data", value: "d" },
                    ]}
                    highlightSection="Business Cycle and Value Creation Process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine is in place to produce LE and analyze AC vs BU for CAPEX spend, Benefits and KPIs for CAPEX projects impacting BSC.",
                      b: "Evidence should include presentation slides, meeting minutes, or decision logs. Monthly T&M routine in place to produce LE and analyze AC vs BU for OPEX spend, incl. total FTE (productivity evolution).",
                      c: "Upload Reports on FTE forecast, AC/LE people costs, drivers of deviation, initiatives.",
                      d: "Upload Data validation reports and compliance checklists for master-data including BSC People Cost Center master-data is correct and in line with People and GBS Policies (applicable for GBS services).",
                    }}
                  />
                }
                userComponent={
                  <UserSectionMultiTabValueCreation
                    fetchAllFilesApi="/strategy/filter_strategy_n_value_creation"
                    fetchFileViewApi="/strategy/strategy_n_value_creation"
                    highlightSection="Business Cycle and Value Creation Process"
                    tabName="Business Cycle and Value Creation Process"
                    verticalTabs={[
                      { label: "T&M Routine - CAPEX", value: "a" },
                      { label: "T&M Routine - OPEX", value: "b" },
                      {
                        label: "People Planning and Performance Management",
                        value: "c",
                      },
                      { label: "People Cost Center master-data", value: "d" },
                    ]}
                  />
                }
              />
            ),
          },

          // Inflow and New demand Process
          {
            path: "/operations/strategy-value-creation/vctra/indp",
            element: (
              <RoleBasedComponent
                key="strategy-value-creation/vctra/indp"
                managerComponent={
                  <InflowdemanProcessSection isManager={true} />
                }
                adminComponent={<InflowdemanProcessSection isAdmin={true} />}
                superadminComponent={
                  <InflowdemanProcessSection isAdmin={true} />
                }
                userComponent={
                  <UserSectionMultiTabValueCreation
                    fetchAllFilesApi="/strategy/filter_strategy_n_value_creation"
                    fetchFileViewApi="/strategy/strategy_n_value_creation"
                    highlightSection="Inflow and New demand Process"
                    tabName="Inflow and New demand Process"
                    verticalTabs={[
                      { label: "Inflow & New demand Methodology", value: "a" },
                      { label: "Rate Card", value: "b" },
                      { label: "Source of funding", value: "c" },
                    ]}
                  />
                }
              />
            ),
          },

          // GBS Cross-charge process
          {
            path: "/operations/strategy-value-creation/vctra/gccp",
            element: (
              <RoleBasedComponent
                key="strategy-value-creation/vctra/gccp"
                managerComponent={
                  <GbsCrossChargeUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="BGBS Cross-charge process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isManager={true}
                    verticalTabs={[
                      { label: "ICO Contracts", value: "a" },
                      { label: "Cross - Charge Process", value: "b" },
                    ]}
                    highlightSection="GBS Cross-charge process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Please upload signed ICO contracts & markup email confirmation from global tax and service receiving zone. As well as markup research provided by external consultant..",
                      b: "Upload all required documentation executed as per process steps stipulated in GBS Cross-charge Policy, incl. performance reporting and statutory invoicing, required frequency, FX impact treatment etc to showcase the policy is on time.",
                    }}
                  />
                }
                adminComponent={
                  <BusinessCycleUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="GBS Cross-charge process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isAdmin={true}
                    verticalTabs={[
                      { label: "ICO Contracts", value: "a" },
                      { label: "Cross - Charge Process", value: "b" },
                    ]}
                    highlightSection="GBS Cross-charge process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Please upload signed ICO contracts & markup email confirmation from global tax and service receiving zone. As well as markup research provided by external consultant..",
                      b: "Upload all required documentation executed as per process steps stipulated in GBS Cross-charge Policy, incl. performance reporting and statutory invoicing, required frequency, FX impact treatment etc to showcase the policy is on time.",
                    }}
                  />
                }
                superadminComponent={
                  <BusinessCycleUpload
                    fetchDataApi="/strategy/filter_strategy_n_value_creation"
                    tabName="GBS Cross-charge process"
                    fileDetailApi="/strategy/strategy_n_value_creation"
                    statusApi=""
                    isAdmin={true}
                    verticalTabs={[
                      { label: "ICO Contracts", value: "a" },
                      { label: "Cross - Charge Process", value: "b" },
                    ]}
                    highlightSection="GBS Cross-charge process"
                    fileTitleMapping={{
                      // Pass the mapping here
                      a: "Please upload signed ICO contracts & markup email confirmation from global tax and service receiving zone. As well as markup research provided by external consultant..",
                      b: "Upload all required documentation executed as per process steps stipulated in GBS Cross-charge Policy, incl. performance reporting and statutory invoicing, required frequency, FX impact treatment etc to showcase the policy is on time.",
                    }}
                  />
                }
                userComponent={
                  <UserSectionMultiTabValueCreation
                    fetchAllFilesApi="/strategy/filter_strategy_n_value_creation"
                    fetchFileViewApi="/strategy/strategy_n_value_creation"
                    highlightSection="GBS Cross-charge process"
                    tabName="GBS Cross-charge process"
                    verticalTabs={[
                      { label: "ICO Contracts", value: "a" },
                      { label: "Cross - Charge Process", value: "b" },
                    ]}
                  />
                }
              />
            ),
          },

          // {
          //   path: "/operations/strategy-value-creation/vctra/gccp/admin",
          //   element: <BusinessCycleUpload fetchDataApi="/strategy/filter_strategy_n_value_creation" tabName="GBS Cross-charge process" fileDetailApi="/strategy/strategy_n_value_creation" statusApi="" isAdmin={true} verticalTabs={[
          //     { label: "ICO Contracts", value: "a" },
          //     { label: "Cross - Charge Process", value: "b" },

          //   ]}

          //     highlightSection="GBS Cross-charge process"
          //     fileTitleMapping={{ // Pass the mapping here
          //       a: "Please upload signed ICO contracts & markup email confirmation from global tax and service receiving zone. As well as markup research provided by external consultant..",
          //       b: "Upload all required documentation executed as per process steps stipulated in GBS Cross-charge Policy, incl. performance reporting and statutory invoicing, required frequency, FX impact treatment etc to showcase the policy is on time.",
          //     }}

          //   />,
          // },

          // {
          //   path: "/operations/strategy-value-creation/vctra/gccp/user",
          //   element: <UserSectionMultiTabValueCreation fetchAllFilesApi="/strategy/filter_strategy_n_value_creation" fetchFileViewApi="/strategy/strategy_n_value_creation" highlightSection="GBS Cross-charge process" tabName="GBS Cross-charge process" verticalTabs={[
          //     { label: "ICO Contracts", value: "a" },
          //     { label: "Cross - Charge Process", value: "b" },

          //   ]} />,
          // },
          // {
          //   path: "finalstatus",
          //   element: <FinalStatus functionL1="Learning" functionL2="Execute with integrity" management="Prague & India GCC" />,
          // },

          {
            path: "*",
            element: "nothing here",
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/callback",
    element: <LoginPage />,
  },
]);

const App: React.FC = () => {
  const msalInstance = new PublicClientApplication(MSAL_CONFIG);

  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </MsalProvider>
  );
};

export default App;
